var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLinkOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 4H4.00008C3.64646 4 3.30732 4.14047 3.05727 4.39052C2.80722 4.64057 2.66675 4.97971 2.66675 5.33333V12C2.66675 12.3536 2.80722 12.6928 3.05727 12.9428C3.30732 13.1929 3.64646 13.3333 4.00008 13.3333H10.6667C11.0204 13.3333 11.3595 13.1929 11.6096 12.9428C11.8596 12.6928 12.0001 12.3536 12.0001 12V9.33333M9.33341 2.66666H13.3334M13.3334 2.66666V6.66666M13.3334 2.66666L6.66675 9.33333",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkOutline);
export default __webpack_public_path__ + "static/media/ExternalLinkOutline.2c0b901913992c9c3600694ee3c8c9d6.svg";
export { ForwardRef as ReactComponent };